import { CompanyMeasurementDate, MeasurementDateRollover, MeasurementDateRolloverReturn } from 'api';
import { Firm } from '../../../common/types/firm';
import { PromiseResult } from '../../../hooks/useRollingApiRequest/useRollingApiRequest.props';

export enum STATUS {
  LOADING = 'loading',
  SUCCESS = 'success',
  ERROR = 'error',
  CONFLICT = 'conflict',
}

export type RolloverStatusList = {
  fundResult: PromiseResult<MeasurementDateRollover, MeasurementDateRolloverReturn>[];
  companyResult: PromiseResult<MeasurementDateRollover, CompanyMeasurementDate | undefined>[];
};
export type SubItem = {
  id: number;
  allocationId?: number;
  name: string;
};
export enum ROLLOVER_TYPE_KEYS {
  FUNDS = 'funds',
  ALLOCATIONS = 'allocations',
  CAP_TABLES_ONLY = 'capTablesOnly',
}

export interface CompanyRollover {
  companyId: number;
  companyName: string;
  customDate?: string | null;
  excludeDocuments: boolean;
  excludeValuation: boolean;
  isFundInvestment?: boolean;
  keepMarketData: boolean;
  marketDate?: string | null;
  resetFinancials: boolean;
  warning?: boolean;
}

export interface RolloverParams {
  rollovers: CompanyRollover[];
  companies: number[];
  funds: number[];
  newMeasurementDate: string;
  firmId: number;
}

export interface UseRolloverParams {
  firmInfo?: Firm | null;
  measurementDate?: string;
  selectedFunds: number[];
  rolloverDetailCompanies: CompanyRollover[];
}
